.ay{max-width:100%;}